
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class IconEstimate extends Vue {
  @Prop({ default: 24 }) size!: number;
}
